import { render, staticRenderFns } from "./SelectSubstituteWorkModal.vue?vue&type=template&id=27e5c400"
import script from "./SelectSubstituteWorkModal.vue?vue&type=script&lang=js"
export * from "./SelectSubstituteWorkModal.vue?vue&type=script&lang=js"
import style0 from "./SelectSubstituteWorkModal.vue?vue&type=style&index=0&id=27e5c400&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports